import get from 'lodash/get';
import { getCardCategoryTags } from '../../../utils/getCardCategoryTags';
import { pageContentType } from '../../../utils/getContentType';
import {
  EVENT_TYPE,
  SIMILAR_EVENT_DETAILS_PAYLOAD_KEY,
} from '../../../../constants/index';
import { TAGS } from '../../../../constants/index';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getPriceRange } from '../../../utils/getPriceRange';
let matchedTagList = [];
let routeFilterArray;
const getMatchingTagsData = props => {
  matchedTagList = [];
  // TODO will move it in centralized place to re-use
  const diningTagsFromDictionary = getDictionaryText(
    `${pageContentType(props)}Filters`
  );
  const diningTagsArrayFromDictionary =
    (diningTagsFromDictionary && diningTagsFromDictionary.split(',')) || [];
  let matchingTagsData = [];
  diningTagsArrayFromDictionary &&
    diningTagsArrayFromDictionary.forEach(tag => {
      routeFilterArray = get(props, `sitecoreContext.route.fields[${tag}]`);
      if (
        get(props, 'sitecoreContext.route.fields', {}).hasOwnProperty(tag) &&
        routeFilterArray &&
        routeFilterArray.length > 0
      ) {
        matchedTagList.push(tag);
        matchingTagsData.push(
          get(props, `sitecoreContext.route.fields[${tag}]`)
        );
      }
    });
  return [matchingTagsData, matchedTagList];
};

const getSimilarSearchEventIds = props => {
  const similarEvents = get(
    props,
    'sitecoreContext.route.fields.similarEvents',
    []
  );

  let idList = [];
  if (similarEvents && similarEvents.length > 0) {
    idList = similarEvents.map((i) => i.id);
  } else {
    const VADMain = props.sitecoreContext.route.placeholders['vad-main'];
    const similarSearchComponent = VADMain.find(item => item.componentName === 'SimilarSearch');
    if (similarSearchComponent) {
      const rse = similarSearchComponent.fields.randomSimilarEvents;
      const rseList = rse.replace(/{/g, '').replace(/}/g, '').split(',');
      idList = rseList.length > 0 ? rseList : []
    }
  }
  return idList;
};

const getMoreLikeThisKeyValues = props => {
  const keyValues = [];
  if (pageContentType(props)?.toLowerCase() === EVENT_TYPE) {
    keyValues.push({
      key: SIMILAR_EVENT_DETAILS_PAYLOAD_KEY,
      values: getSimilarSearchEventIds(props),
    });
  } else {
    const matchingTagsData = getMatchingTagsData(props);
    matchingTagsData[0].forEach((tagData, tagDataIndex) => {
      tagData &&
        tagData.forEach((tagItem, tagItemIndex) => {
          if (tagItemIndex === 0) {
            keyValues.push({
              key: get(tagItem, 'fields.taxonomyKey.value', ''),
              values: [get(tagItem, 'fields.searchKey.value', '')],
            });
          } else {
            keyValues[tagDataIndex].values.push(
              get(tagItem, 'fields.searchKey.value', '')
            );
          }
        });
    });
  }

  return keyValues;
};

const getRelatedEventsKeyValues = props => {
  const eventCategories = get(props, 'sitecoreContext.route.fields.eventCategory', '');
  const keyValues = [];

  eventCategories && eventCategories.length > 0 && eventCategories.forEach(item => {
    keyValues.push({
      key: get(item, 'fields.taxonomyKey.value', ''),
      values: [get(item, 'fields.searchKey.value', '')],
    });
  })
  return keyValues;
};

const getCategoryTags = (props, item) => {
  const contentType = pageContentType(props).toLowerCase();
  const dictionary = getDictionaryText(`${contentType}${TAGS}`);
  const tags = getCardCategoryTags(item, dictionary);
  return tags;
};

const getBranchesKeyValues = props => {
  const keyValues = [];
  keyValues.push({
    key: 'uniquename', //This is fixed as of now
    values: [get(props, 'sitecoreContext.route.fields.uniqueName.value', '')],
  });
  return keyValues;
};

export const getRequestBody = (props, variation, isEditor) => {
  const currentItemId = get(props, 'sitecoreContext.route.itemId', '');
  const limit = Number(get(props, 'fields.pageSize.value', 0));
  const requestBody = {
    contentType: pageContentType(props).toLowerCase(),
    currentItemId: currentItemId,
    language: get(props, 'sitecoreContext.language', ''),
    isPreviewMode: isEditor,
    offset: 0,
    limit: (variation === 'MoreLikeThis' || variation === 'RelatedEvents') ? limit : 50, // As discussed with sitecore, we will taking all the data at a time
    keyValues:
      variation === 'Branches'
        ? getBranchesKeyValues(props)
        : variation === 'RelatedEvents'
          ? getRelatedEventsKeyValues(props)
          : getMoreLikeThisKeyValues(props),
  };
  return requestBody;
};

export const getProcessedProps = (props, results) => {
  return {
    fields: {
      cardList: getCardList(props, results),
    },
  };
};

const getCardList = (props, results) => {
  const featuredText = getDictionaryText('featuredText');
  const cardItems = [];
  results &&
    results.length > 0 &&
    results.forEach(item => {
      const thumbnailSrc = {
        src: get(item, 'thumbnailImage', ''),
        alt: get(item, 'title', ''),
        '3x2-card': {
          'large': get(item, 'thumbnailImage', ''),
        },
      };
      const thumbnailImage = {
        value:
          pageContentType(props).toLowerCase() === EVENT_TYPE
            ? thumbnailSrc
            : get(item, 'thumbnailImage', ''),
      };
      cardItems.push({
        fields: {
          primaryCTA: {
            value: {
              href: item.itemUrl,
              text: '',
              anchor: '',
              linktype: 'internal',
              class: '',
              title: '',
              target: '',
              querystring: '',
            },
          },
          title: { value: item.name },
          attributeLabelCTA: getCategoryTags(props, item),
          backgroundColor: {
            value: 'white',
          },
          desktopImage: thumbnailImage,
          mobileImage: thumbnailImage,
          location: item.location,
          startDate: item.startDate,
          endDate: item.endDate,
          openTime: item.openTime,
          closeTime: item.closeTime,
          umbrellaEventCount: item.umbrellaEventCount,
          eventType: {
            featured: item.isFeatured && featuredText,
            isPaid: item.eventType,
          },
          locationTitle: {
            value:
              get(item, 'location_Titles.length') > 0 &&
              item.location_Titles[0],
          },
          region: {
            value:
              get(item, 'location_Regions.length') > 0 &&
              item.location_Regions[0],
          },
          urlSlug: item.urlSlug,
          viewsCount: item.viewsCount,
          tripAdvisorRating: item.tripAdvisorRating,
          num_reviews: item.tripAdvisorNumberOfReviews,
          rating_image_url: item.tripAdvisorRatingImageURL,
          googlePlaceId: item.googlePlaceId,
          priceTagsKeys: item.priceTagsKeys,
          expenseRange: getPriceRange(item.priceTags),
          itemUniqueKey: item.itemUniqueKey,
        },
      });
    });
  return cardItems;
};


